<script></script>

<template>
  <main :class="$i18n.locale" class="relative overflow-hidden">
    <slot />
  </main>
</template>
